export const STATUS_PAGE = 'https://status.cashfree.com';

export const KNOW_MORE = {
  EMAIL_NOTIFICATIONS:
    'https://www.cashfree.com/docs/payouts/payouts/dashboard/set-email-notifications',
  DEVELOPERS: {
    API_KEYS:
      'https://www.cashfree.com/docs/api-reference/vrs/getting-started#generate-api-keys',
    WEBHOOKS: 'https://docs.cashfree.com/docs/payouts-notifications',
    '2FA':
      'https://www.cashfree.com/docs/api-reference/vrs/getting-started#whitelist-your-ip-address',
  },
  ACCOUNT: {
    SUMMARY:
      'https://www.cashfree.com/docs/secure-id/get-started/wallet-recharge',
    RECHARGE: 'https://docs.cashfree.com/docs/payout-accounts#account-summary',
  },
  BAV: {
    ALL:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/bav-v2/bank-account-verification-sync-v2',
    BATCH:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/bav-v2/bulk-bank-account-verification-v2',
    APPROVE_BATCH:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/bav-v2/approve-batch',
    VERIFY_UPI: 'https://docs.cashfree.com/reference/upi-verification',
    VERIFY_IFSC:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/ifsc/ifsc-verification-v2',
    VERIFY_GSTIN:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/gstin/verify-gstin',
    VERIFY_OKYC:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/aadhaar/submit-otp-to-verify-aadhaar',
  },
  PAN: {
    ALL:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/pan/verify-pan-sync',
    BATCH:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/pan/verify-pan-in-bulk',
    VERIFY: 'https://www.cashfree.com/docs/api-reference/vrs/v2/pan/pan-360',
  },
  FORMS: {
    BATCH:
      'https://www.cashfree.com/docs/api-reference/vrs/v2/kyc-links/get-form-status',
  },
};
